import { render } from "./Tacos.vue?vue&type=template&id=3718dbec&scoped=true"
import script from "./Tacos.vue?vue&type=script&lang=js"
export * from "./Tacos.vue?vue&type=script&lang=js"

import "./Tacos.vue?vue&type=style&index=0&id=3718dbec&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3718dbec"]])

export default __exports__